import { NgModule } from '@angular/core';
import { HeroVideoComponent } from './hero-video.component';
import { CommonModule } from '@angular/common';
import {PipesModule} from '../../pipes.module';

@NgModule({
  imports: [
    CommonModule,
    PipesModule
  ],
  declarations: [
    HeroVideoComponent
  ],
  exports: [
    HeroVideoComponent
  ]
})
export class HeroVideoModule { }
